module.exports = __webpack_public_path__ + "assets/img/email-a1752e74.png";